import React, { useEffect, useState } from "react";
import axios from "axios";

const SeoSettings = () => {
  const [selectedPage, setSelectedPage] = useState("home");
  const accessToken = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    metaRedirect: "",
    metaCanonical: "",
    metaHtmlHead: "",
    metaHtmlFooter: "",
    ogImage: null,
  });

  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const pages = [
    { value: "home", label: "Home" },
    { value: "about-us", label: "About Us" },
    { value: "contact-us", label: "Contact Us" },
    { value: "properties", label: "Properties" },
    { value: "listings", label: "Listings" },
    { value: "services", label: "Services" },
    { value: "list-with-us", label: "List With Us" },
    { value: "blog", label: "Blog" },
  ];

  // Fetch SEO data when selectedPage changes
  useEffect(() => {
    const fetchSeoData = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `https://365luxuryhomes.com/api/seo-settings/${selectedPage}`
        );
        const seoData = response.data;

        setFormData({
          metaTitle: seoData.metaTitle || "",
          metaDescription: seoData.metaDescription || "",
          metaKeywords: seoData.metaKeywords || "",
          metaRedirect: seoData.metaRedirect || "",
          metaCanonical: seoData.metaCanonical || "",
          metaHtmlHead: seoData.metaHtmlHead || "",
          metaHtmlFooter: seoData.metaHtmlFooter || "",
          ogImage: seoData.ogImage || null,
        });
        setPreviewImage(seoData.ogImage || null);
        console.log(seoData); // Debug log
      } catch (error) {
        console.error("Error fetching SEO data:", error);
        alert("No data found for this page!");
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, [selectedPage]);

  const handlePageChange = (e) => {
    setSelectedPage(e.target.value);
    setFormData({
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      metaRedirect: "",
      metaCanonical: "",
      metaHtmlHead: "",
      metaHtmlFooter: "",
      ogImage: null,
    });
    setPreviewImage(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, ogImage: file });
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();
      form.append("ogImage", formData.ogImage);
      form.append("metaTitle", formData.metaTitle);
      form.append("metaDescription", formData.metaDescription);
      form.append("metaKeywords", formData.metaKeywords);
      form.append("metaRedirect", formData.metaRedirect);
      form.append("metaCanonical", formData.metaCanonical);
      form.append("metaHtmlHead", formData.metaHtmlHead);
      form.append("metaHtmlFooter", formData.metaHtmlFooter);
      form.append("page", selectedPage);

      const response = await axios.post(
        "https://365luxuryhomes.com/api/seo-settings",
        form,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(response.data.message);
    } catch (error) {
      console.error("Error updating SEO settings:", error);
      alert("Failed to update SEO settings.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="lg:py-20 md:py-14 py-10 bg-white">
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-semibold mb-6">SEO Settings</h1>
        <div className="mb-6">
          <label className="block text-[#aca9a5] mb-2">Select Page</label>
          <select
            value={selectedPage}
            onChange={handlePageChange}
            className="border rounded w-full p-2 bg-transparent text-[#aca9a5]"
          >
            {pages.map((page) => (
              <option key={page.value} value={page.value}>
                {page.label}
              </option>
            ))}
          </select>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-[#aca9a5]">Meta Title</label>
              <input
                type="text"
                name="metaTitle"
                value={formData.metaTitle}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-[#aca9a5]">Meta Description</label>
              <textarea
                name="metaDescription"
                value={formData.metaDescription}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
                rows="4"
                required
              ></textarea>
            </div>
            <div>
              <label className="block text-[#aca9a5]">Meta Keywords</label>
              <input
                type="text"
                name="metaKeywords"
                value={formData.metaKeywords}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-[#aca9a5]">Meta Redirect</label>
              <input
                type="url"
                name="metaRedirect"
                value={formData.metaRedirect}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
              />
            </div>
            <div>
              <label className="block text-[#aca9a5]">Meta Canonical</label>
              <input
                type="url"
                name="metaCanonical"
                value={formData.metaCanonical}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-[#aca9a5]">Meta HTML Head</label>
              <textarea
                name="metaHtmlHead"
                value={formData.metaHtmlHead}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
                rows="4"
              ></textarea>
            </div>
            <div>
              <label className="block text-[#aca9a5]">Meta HTML Footer</label>
              <textarea
                name="metaHtmlFooter"
                value={formData.metaHtmlFooter}
                onChange={handleInputChange}
                className="border rounded w-full p-2 bg-transparent"
                rows="4"
              ></textarea>
            </div>
            <div>
              <label className="block text-[#aca9a5]">OG Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="border rounded w-full p-2 bg-transparent"
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="OG Preview"
                  className="mt-2 w-40 h-40 object-cover rounded border"
                />
              )}
              <p className="text-[#aca9a5] text-sm mt-1">
                Supported: jpeg, png, webp. Max size: 10 MB.
              </p>
            </div>
          </div>
          <button
            type="submit"
            className="mt-6 px-4 py-2 bg-[#aca9a5] text-white rounded hover:bg-[#6c675b]"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default SeoSettings;
